import { PDFDocument } from "pdf-lib";

export const PAGE_WIDTH = 650;

export const DEFAULT_PLACEMENT_WIDTH_FRACTION = 0.25;

export const ACCEPTED_SIGNATURE_TYPES = ["image/png", "image/jpeg"];

export const getImageDimensions = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: image.naturalWidth, height: image.naturalHeight });
    };
    image.onerror = (error) => {
      URL.revokeObjectURL(url);
      reject(error);
    };
    image.src = url;
  });

// `pdfFile` is either a local File/Blob (manual upload) or a remote URL string (auto-loaded
// source document), so the bytes are read differently depending on which one it is.
const readPdfBytes = (pdfFile) =>
  typeof pdfFile === "string"
    ? fetch(pdfFile).then((res) => res.arrayBuffer())
    : pdfFile.arrayBuffer();

// Returns the signed PDF as a Blob — the caller decides whether to download it, upload it, etc.
export const generateSignedPdf = async ({
  pdfFile,
  signatureFile,
  placements,
}) => {
  const pdfBytes = await readPdfBytes(pdfFile);
  const pdfDoc = await PDFDocument.load(pdfBytes);
  const pages = pdfDoc.getPages();

  const signatureBytes = await signatureFile.arrayBuffer();
  const signatureImage =
    signatureFile.type === "image/png"
      ? await pdfDoc.embedPng(signatureBytes)
      : await pdfDoc.embedJpg(signatureBytes);

  Object.entries(placements).forEach(([pageNumber, placement]) => {
    if (!placement) {
      return;
    }
    const page = pages[Number(pageNumber) - 1];
    if (!page) {
      return;
    }
    const { width, height } = page.getSize();
    const signatureWidth = placement.wFrac * width;
    const signatureHeight = placement.hFrac * height;
    const x = placement.xFrac * width;
    // PDF coordinates originate at the bottom-left, screen coordinates at the top-left.
    const y = height - placement.yFrac * height - signatureHeight;

    page.drawImage(signatureImage, {
      x,
      y,
      width: signatureWidth,
      height: signatureHeight,
    });
  });

  const signedBytes = await pdfDoc.save();
  return new Blob([signedBytes], { type: "application/pdf" });
};

export const getPdfFileBaseName = (pdfFile) =>
  (typeof pdfFile === "string" ? pdfFile.split("/").pop() : pdfFile?.name)
    ?.replace(/\.pdf$/i, "")
    ?.split(/[?#]/)[0] || "document";
